import { jsPDF as JSPDF } from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { sToHMSColonSeparated } from '../../../helpers';

const OvertimeReportPDF = (overtimeData, fromDate, toDate, currency) => {
  const doc = new JSPDF('l', 'pt', 'a3');
  const totalPagesExp = '{total_pages_count_string}';
  const pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  const tableColumns = {};
  for (let i = 0; i < 10; i += 1) {
    tableColumns[i] = { halign: i === 0 ? 'left' : 'center' };
  }

  const tableRows = [];

  doc.setFontSize(10);
  doc.text(
    `Period: ${moment(fromDate).format('MMM DD, YYYY')} - ${moment(
      toDate
    ).format('MMM DD, YYYY')}`,
    40,
    60,
    'left'
  );

  overtimeData
    .sort((a, b) => (a.user.firstName < b.user.firstName ? -1 : 1))
    .forEach((entry) => {
      tableRows.push([
        `${entry.user.firstName} ${entry.user.lastName || ''}`,
        sToHMSColonSeparated(Math.round(entry.workSessionHours * 60 * 60)),
        sToHMSColonSeparated(Math.round(entry.overTimeHours * 60 * 60)),
        entry.regularPay ? entry.regularPay.toFixed(2) : '0.00',
        entry.overTimePay ? entry.overTimePay.toFixed(2) : '0.00',
        entry.overTimePay || entry.regularPay
          ? (entry.overTimePay + entry.regularPay).toFixed(2)
          : '0.00',
      ]);
    });

  const cur = currency ? ` (${currency})` : '';
  const tableColumn = [
    'Team Member',
    'Logged Hours',
    'Overtime',
    `Regular Time Pay${cur}`,
    `OT Pay${cur}`,
    `Gross Pay${cur}`,
  ];

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 75,
    theme: 'grid',
    styles: { cellPadding: 10 },
    headStyles: {
      fillColor: [237, 242, 249],
      textColor: [40, 62, 89],
      halign: 'center',
    },
    columnStyles: tableColumns,
    footStyles: {
      fillColor: [237, 242, 249],
      textColor: [18, 38, 63],
      halign: 'center',
    },
    tableLineColor: [237, 242, 249],
    tableLineWidth: 1,
    showFoot: 'lastPage',
    didDrawPage() {
      doc.setFontSize(14);
      doc.setTextColor(40);
      doc.text('Overtime Report', pageWidth / 2, 23, 'center');
      doc.setFontSize(10);
      let str = `Page ${doc.internal.getNumberOfPages()}`;
      if (typeof doc.putTotalPages === 'function') {
        str = `${str} of ${totalPagesExp}`;
      }
      const { pageSize } = doc.internal;
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      doc.text(str, 1100, pageHeight - 22);
    },
  });

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  doc.save('overtime_report.pdf');
};

export default OvertimeReportPDF;
